var $6b17f08f738443dc$exports = {};
"use strict";
// Buttons
const $6b17f08f738443dc$var$btnOpenModal = document.querySelector(".show-modal");
const $6b17f08f738443dc$var$btnCloseModal = document.querySelector(".close-modal");
const $6b17f08f738443dc$var$modal = document.querySelector(".modal");
const $6b17f08f738443dc$var$resetGameBtn = document.querySelector("#reset--btn");
const $6b17f08f738443dc$var$overlay = document.querySelector(".overlay");
const $6b17f08f738443dc$var$keyboard = document.querySelectorAll(".keyboard--key");
const $6b17f08f738443dc$var$enterKey = document.querySelector("#enter-key");
const $6b17f08f738443dc$var$body = document.querySelector("body");
const $6b17f08f738443dc$var$msgContainer = document.querySelector(".message--container");
const $6b17f08f738443dc$var$guessContainer = document.querySelector(".guess--container");
const $6b17f08f738443dc$var$grayHintTile = document.querySelector("#hint--gray");
const $6b17f08f738443dc$var$yellowHintTile = document.querySelector("#hint--yellow");
const $6b17f08f738443dc$var$greenHintTile = document.querySelector("#hint--green");
const $6b17f08f738443dc$var$toggleThemeBtn = document.querySelector("#toggle--theme");
const $6b17f08f738443dc$var$themeBall = document.querySelector(".ball");
// Data structures for the game
let $6b17f08f738443dc$var$wordRows = [
    [
        "",
        "",
        "",
        "",
        ""
    ],
    [
        "",
        "",
        "",
        "",
        ""
    ],
    [
        "",
        "",
        "",
        "",
        ""
    ],
    [
        "",
        "",
        "",
        "",
        ""
    ],
    [
        "",
        "",
        "",
        "",
        ""
    ],
    [
        "",
        "",
        "",
        "",
        ""
    ]
];
let $6b17f08f738443dc$var$currentRow = 0;
let $6b17f08f738443dc$var$currentTile = 0;
let $6b17f08f738443dc$var$secretWord;
let $6b17f08f738443dc$var$gameOver = false;
let $6b17f08f738443dc$var$tempDisableAllInput = false;
// Get random word using fetch API
const $6b17f08f738443dc$var$guessOptions = {
    method: "GET",
    headers: {
        "X-RapidAPI-Host": "random-words5.p.rapidapi.com",
        "X-RapidAPI-Key": "49e442de95mshc0a2d53e7e9181cp175d85jsnf7691a0e4630"
    }
};
const $6b17f08f738443dc$var$getRandomWord = async ()=>{
    const res = await fetch("https://random-words5.p.rapidapi.com/getMultipleRandom?count=1&wordLength=5", $6b17f08f738443dc$var$guessOptions);
    const data = await res.json();
    $6b17f08f738443dc$var$secretWord = data[0].toUpperCase();
};
$6b17f08f738443dc$var$getRandomWord();
// Toggle light and dark theme
$6b17f08f738443dc$var$toggleThemeBtn.addEventListener("click", ()=>{
    const body = document.querySelector("body");
    body.classList.toggle("active--dark");
    $6b17f08f738443dc$var$themeBall.classList.toggle("toggle--dark");
});
// Open Modal
$6b17f08f738443dc$var$btnOpenModal.addEventListener("click", ()=>{
    $6b17f08f738443dc$var$modal.classList.remove("hidden");
    $6b17f08f738443dc$var$overlay.classList.remove("hidden");
    $6b17f08f738443dc$var$grayHintTile.classList.add("tile--flip", "gray--overlay");
    $6b17f08f738443dc$var$yellowHintTile.classList.add("tile--flip", "yellow--overlay");
    $6b17f08f738443dc$var$greenHintTile.classList.add("tile--flip", "green--overlay");
    $6b17f08f738443dc$var$tempDisableAllInput = true;
    $6b17f08f738443dc$var$body.style.overflow = "hidden";
});
// Close Modal
$6b17f08f738443dc$var$btnCloseModal.addEventListener("click", ()=>{
    $6b17f08f738443dc$var$modal.classList.add("hidden");
    $6b17f08f738443dc$var$overlay.classList.add("hidden");
    $6b17f08f738443dc$var$grayHintTile.classList.remove("tile--flip", "gray--overlay");
    $6b17f08f738443dc$var$yellowHintTile.classList.remove("tile--flip", "yellow--overlay");
    $6b17f08f738443dc$var$greenHintTile.classList.remove("tile--flip", "green--overlay");
    $6b17f08f738443dc$var$tempDisableAllInput = false;
    $6b17f08f738443dc$var$body.style.overflow = "initial";
});
// Add letter to tile
const $6b17f08f738443dc$var$addLetter = function(letter) {
    if ($6b17f08f738443dc$var$gameOver || $6b17f08f738443dc$var$tempDisableAllInput) return;
    if ($6b17f08f738443dc$var$currentRow > 5 || $6b17f08f738443dc$var$currentTile > 4) return;
    $6b17f08f738443dc$var$wordRows[$6b17f08f738443dc$var$currentRow][$6b17f08f738443dc$var$currentTile] = letter;
    const tile = document.getElementById(`row-${$6b17f08f738443dc$var$currentRow} tile-${$6b17f08f738443dc$var$currentTile}`);
    $6b17f08f738443dc$var$currentTile++;
    tile.textContent = letter;
};
// Delete letter fromt tile
const $6b17f08f738443dc$var$deleteLetter = ()=>{
    if ($6b17f08f738443dc$var$gameOver || $6b17f08f738443dc$var$tempDisableAllInput) return;
    if ($6b17f08f738443dc$var$currentTile <= 0) return;
    $6b17f08f738443dc$var$currentTile--;
    const tile = document.getElementById(`row-${$6b17f08f738443dc$var$currentRow} tile-${$6b17f08f738443dc$var$currentTile}`);
    tile.textContent = "";
};
// Display relevant game message
const $6b17f08f738443dc$var$displayMessage = (message)=>{
    const messageEl = document.createElement("p");
    messageEl.textContent = message;
    $6b17f08f738443dc$var$msgContainer.insertAdjacentElement("beforeend", messageEl);
    $6b17f08f738443dc$var$tempDisableAllInput = true;
    setTimeout(()=>{
        $6b17f08f738443dc$var$msgContainer.removeChild(messageEl);
        $6b17f08f738443dc$var$tempDisableAllInput = false;
    }, 3000);
};
// Display the secret word if lost
const $6b17f08f738443dc$var$displayGuess = ()=>{
    const guessEl = document.createElement("p");
    guessEl.textContent = `The word was ${$6b17f08f738443dc$var$secretWord}`;
    $6b17f08f738443dc$var$guessContainer.insertAdjacentElement("beforeend", guessEl);
    setTimeout(()=>{
        $6b17f08f738443dc$var$guessContainer.removeChild(guessEl);
    }, 3000);
};
// Add gray, yellow and green hints to tiles
const $6b17f08f738443dc$var$highlightAnswer = (userAnswer)=>{
    if ($6b17f08f738443dc$var$gameOver) return;
    let checkSecretWord = $6b17f08f738443dc$var$secretWord;
    const guess = [];
    const rowTiles = document.getElementById(`guessRow-${$6b17f08f738443dc$var$currentRow}`).querySelectorAll(".letter--box");
    rowTiles.forEach((tile)=>{
        guess.push({
            letter: tile.textContent,
            color: "gray"
        });
    });
    guess.forEach((guess)=>{
        if (checkSecretWord.includes(guess.letter)) {
            guess.color = "yellow";
            checkSecretWord = checkSecretWord.replace(guess.letter, "");
        }
    });
    guess.forEach((guess, index)=>{
        if (guess.letter === $6b17f08f738443dc$var$secretWord[index]) {
            guess.color = "green";
            checkSecretWord = checkSecretWord.replace(guess.letter, "");
        }
    });
    const interval = 500;
    rowTiles.forEach((tile, index)=>{
        setTimeout(()=>{
            tile.classList.add("tile--flip");
            tile.classList.add(`${guess[index].color}--overlay`);
            document.getElementById(`${guess[index].letter}`).classList.add(`${guess[index].color}--overlay`);
        }, interval * index);
    });
    if ($6b17f08f738443dc$var$currentRow <= 5) {
        $6b17f08f738443dc$var$currentRow++;
        $6b17f08f738443dc$var$currentTile = 0;
    }
    $6b17f08f738443dc$var$tempDisableAllInput = true;
    setTimeout(()=>{
        $6b17f08f738443dc$var$tempDisableAllInput = false;
        if (userAnswer.join("") === $6b17f08f738443dc$var$secretWord) {
            $6b17f08f738443dc$var$displayMessage("Wonderful");
            $6b17f08f738443dc$var$gameOver = true;
        } else if ($6b17f08f738443dc$var$currentRow > 5) {
            $6b17f08f738443dc$var$displayMessage("Better Luck Next Time");
            $6b17f08f738443dc$var$displayGuess(`The word is ${$6b17f08f738443dc$var$secretWord}`);
            $6b17f08f738443dc$var$gameOver = true;
            return;
        }
    }, 5 * interval);
};
// Check the submitted guess by user
const $6b17f08f738443dc$var$checkAnswer = ()=>{
    if ($6b17f08f738443dc$var$currentTile < 5 || $6b17f08f738443dc$var$tempDisableAllInput) return;
    $6b17f08f738443dc$var$highlightAnswer($6b17f08f738443dc$var$wordRows[$6b17f08f738443dc$var$currentRow]);
};
// Check keypress of on-screen keyboard
const $6b17f08f738443dc$var$keyPress = (key)=>{
    if (key.getAttribute("id") === "back-key") $6b17f08f738443dc$var$deleteLetter();
    else if (key.getAttribute("id") === "enter-key") $6b17f08f738443dc$var$checkAnswer();
    else $6b17f08f738443dc$var$addLetter(key.textContent);
};
// Listen for keypress on on-screen keyboard
$6b17f08f738443dc$var$keyboard.forEach((key)=>{
    key.addEventListener("click", ()=>$6b17f08f738443dc$var$keyPress(key));
});
// Check if keypress is single letter word 
const $6b17f08f738443dc$var$isLetter = (char)=>{
    if (char.length === 1) return /[A-Z]/.test(char);
    return false;
};
// Listen for keypress on local user keyboard
document.addEventListener("keydown", (e)=>{
    const letter = e.key.toUpperCase();
    if (e.ctrlKey || e.shiftKey) return;
    if ($6b17f08f738443dc$var$isLetter(letter)) $6b17f08f738443dc$var$addLetter(letter);
    if (letter === "ENTER") $6b17f08f738443dc$var$checkAnswer();
    if (letter === "BACKSPACE") $6b17f08f738443dc$var$deleteLetter();
});
// Temporarily Disable reset button after resetting game
const $6b17f08f738443dc$var$tempDisableReset = ()=>{
    $6b17f08f738443dc$var$resetGameBtn.removeEventListener("click", $6b17f08f738443dc$var$resetGame);
    setTimeout(()=>$6b17f08f738443dc$var$resetGameBtn.addEventListener("click", $6b17f08f738443dc$var$resetGame), 3000);
};
// Reset game on pressing reset button
const $6b17f08f738443dc$var$resetGame = ()=>{
    if ($6b17f08f738443dc$var$tempDisableAllInput) return;
    $6b17f08f738443dc$var$displayMessage("Game has been reset");
    $6b17f08f738443dc$var$tempDisableReset();
    $6b17f08f738443dc$var$getRandomWord();
    $6b17f08f738443dc$var$gameOver = false;
    $6b17f08f738443dc$var$tempDisableAllInput = false;
    $6b17f08f738443dc$var$currentRow = 0;
    $6b17f08f738443dc$var$currentTile = 0;
    $6b17f08f738443dc$var$wordRows = [
        [
            "",
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            "",
            ""
        ],
        [
            "",
            "",
            "",
            "",
            ""
        ]
    ];
    const tiles = document.querySelectorAll(".letter--box");
    tiles.forEach((tile)=>{
        tile.textContent = "";
        tile.classList.remove("tile--flip", "green--overlay", "yellow--overlay", "gray--overlay");
    });
    const keyboardKeys = document.querySelectorAll(".keyboard--key");
    keyboardKeys.forEach((key)=>{
        key.classList.remove("green--overlay", "yellow--overlay", "gray--overlay");
    });
};
// Button to reset the game
$6b17f08f738443dc$var$resetGameBtn.addEventListener("click", $6b17f08f738443dc$var$resetGame);


//# sourceMappingURL=index.146800f1.js.map
